export const THEME_MODE_COOKIE_NAME = 'yakit_b2b_theme_mode';

export const DARK_COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';

export const THEME_MODE_COOKIE_OPTIONS = { path: '/', sameSite: 'none' as const, secure: true, expires: 365 };

export const DEFAULT_THEME_MODE = 'system' as const;
